// SVG flag components for consistent cross-platform rendering
// Using simple, clean flag representations

const flags: Record<string, React.FC<{ className?: string }>> = {
  es: ({ className }) => (
    <svg className={className} viewBox="0 0 640 480" xmlns="http://www.w3.org/2000/svg">
      <rect width="640" height="480" fill="#c60b1e"/>
      <rect width="640" height="240" y="120" fill="#ffc400"/>
    </svg>
  ),
  de: ({ className }) => (
    <svg className={className} viewBox="0 0 640 480" xmlns="http://www.w3.org/2000/svg">
      <rect width="640" height="160" fill="#000"/>
      <rect width="640" height="160" y="160" fill="#d00"/>
      <rect width="640" height="160" y="320" fill="#ffce00"/>
    </svg>
  ),
  fr: ({ className }) => (
    <svg className={className} viewBox="0 0 640 480" xmlns="http://www.w3.org/2000/svg">
      <rect width="213.3" height="480" fill="#002395"/>
      <rect width="213.3" height="480" x="213.3" fill="#fff"/>
      <rect width="213.3" height="480" x="426.6" fill="#ed2939"/>
    </svg>
  ),
  it: ({ className }) => (
    <svg className={className} viewBox="0 0 640 480" xmlns="http://www.w3.org/2000/svg">
      <rect width="213.3" height="480" fill="#009246"/>
      <rect width="213.3" height="480" x="213.3" fill="#fff"/>
      <rect width="213.3" height="480" x="426.6" fill="#ce2b37"/>
    </svg>
  ),
  pt: ({ className }) => (
    <svg className={className} viewBox="0 0 640 480" xmlns="http://www.w3.org/2000/svg">
      <rect width="640" height="480" fill="#f00"/>
      <rect width="256" height="480" fill="#060"/>
      <circle cx="256" cy="240" r="64" fill="#ff0" stroke="#060" strokeWidth="4"/>
    </svg>
  ),
  en: ({ className }) => (
    <svg className={className} viewBox="0 0 640 480" xmlns="http://www.w3.org/2000/svg">
      <rect width="640" height="480" fill="#012169"/>
      <path d="M0 0l640 480M640 0L0 480" stroke="#fff" strokeWidth="60"/>
      <path d="M0 0l640 480M640 0L0 480" stroke="#c8102e" strokeWidth="40" clipPath="url(#a)"/>
      <clipPath id="a"><path d="M320 0v240H0v60h320v180h60V300h260v-60H380V0z"/></clipPath>
      <path d="M290 0v210H0v60h290v210h60V270h290v-60H350V0z" fill="#fff"/>
      <path d="M300 0v220H0v40h300v220h40V260h300v-40H340V0z" fill="#c8102e"/>
    </svg>
  ),
};

export type FlagCode = keyof typeof flags;

interface FlagIconProps {
  code: string;
  className?: string;
}

export const FlagIcon = ({ code, className = "w-5 h-3.5" }: FlagIconProps) => {
  const Flag = flags[code];
  if (!Flag) return <span className={className}>🌐</span>;
  return (
    <span className={`inline-flex items-center justify-center overflow-hidden rounded-[2px] shrink-0 ${className}`}>
      <Flag className="w-full h-full" />
    </span>
  );
};

export default FlagIcon;
